import { ResultOk } from "@/types/resultok";
import { ApiFullTagDescription, api } from "..";
import { buildQueryString } from "./utils";
import {Feedback, UserProfile, UserSign} from "@/types/user";

export const userApi = api.injectEndpoints({
  endpoints: (build) => ({
    register: build.mutation<UserProfile, { user: UserProfile, tId?:string,origin?:string,location?:string,ttClickId?:string,txClickId1?:string,txClickId2?:string }>({
      query: ({ user,tId,origin,location,ttClickId,txClickId1,txClickId2 }) => (
        {
        url: `/users${buildQueryString({tId,origin,location,ttClickId,txClickId1,txClickId2})}`,
        method: "POST",
        body: user,
      }),invalidatesTags: ["User"],
    }),
    getCode: build.mutation<ResultOk, { phone: string}>({
      query: (body) => ({
        url: `/users/sms/send`,
        method: "POST",
        body,
      }),
      transformErrorResponse: (baseQueryReturnValue, meta, arg) => baseQueryReturnValue.data,
    }),
    // 签到状态
    getSignStatus: build.query<any, {userId: string}>({
      query:({userId})=>`/users/${userId}/sign_status`,
      transformErrorResponse: (baseQueryReturnValue, meta, arg) => baseQueryReturnValue.data,
    }),
    // 签到
    postSign: build.mutation<ResultOk, { userId: string}>({
      query: ({ userId }) => ({
        url: `/users/${userId}/sign`,
        method: "POST",
        body: {
          userId: userId,
        },
      }),
      transformErrorResponse: (baseQueryReturnValue, meta, arg) => baseQueryReturnValue.data,
      invalidatesTags: ["UserSign"],
    }),
    //获取签到列表
    getSigns:build.query<UserSign[],{ userId: string}>({
      query:({userId}) =>`/users/${userId}/signs`,
      transformErrorResponse: (baseQueryReturnValue, meta, arg) => baseQueryReturnValue.data,
      providesTags: ["UserSign"],
    }),
    // 
    getMe:build.query<UserProfile, void>({
      query:()=>`/users/me`,
      transformErrorResponse: (baseQueryReturnValue, meta, arg) => baseQueryReturnValue.data,
      providesTags: ['User'],
    }),
    //更新用户信息
    UpdateUser:build.mutation<UserProfile,UserProfile>({
      query:(body)=>({
        url: `/users/${body.id}/patch`,
        method: "PUT",
        body,
      }),
      transformErrorResponse: (baseQueryReturnValue, meta, arg) => baseQueryReturnValue.data,
      invalidatesTags: ["User"],
    }),
    //更新用户头像
    updateUserImage:build.mutation<ResultOk,{userId: string, imageData: FormData}>({
      query:(data)=>({
        url: `/users/${data.userId}/image`,
        method: "POST",
        body:data.imageData,
      }),
      transformErrorResponse: (baseQueryReturnValue, meta, arg) => baseQueryReturnValue.data,
      invalidatesTags: ["User"],
    }),
    //更新用户头像
    updateUserBgImage:build.mutation<ResultOk,{userId: string, imageData: FormData}>({
      query:(data)=>({
        url: `/users/${data.userId}/bgimage`,
        method: "POST",
        body:data.imageData,
      }),
      transformErrorResponse: (baseQueryReturnValue, meta, arg) => baseQueryReturnValue.data,
      invalidatesTags: ["User"],
    }),
    logout:build.mutation<ResultOk,void>({
      query:()=>({
        url:`/users/logout`,
        method:"POST"
      })
    }),

    //更新内容
    updateFeedbackInfo:build.mutation<ResultOk,Feedback>({
      query: (feedback) => ({
        url: `/users/feedback`,
        method: 'POST',
        body: feedback,
      }),
      transformErrorResponse: (baseQueryReturnValue, meta, arg) => baseQueryReturnValue.data,
    }),

  }),
});

export const { 
  useGetSignStatusQuery, 
  usePostSignMutation, 
  useLazyGetMeQuery,
  useGetSignsQuery,
  useGetCodeMutation,
  useRegisterMutation, 
  useUpdateUserMutation, 
  useUpdateUserImageMutation,
  useUpdateUserBgImageMutation,
  useLogoutMutation,
  useUpdateFeedbackInfoMutation
} = userApi;

